import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'mail-third-party-glyph-icon'

export function MailSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M4.622 7.108c-.582 0-1.066.423-1.066.933v14.918c0 .51.484.933 1.066.933h22.756c.582 0 1.066-.423 1.066-.933V8.041c0-.51-.484-.933-1.066-.933H4.622Zm0-3.108h22.756C29.924 4 32 5.815 32 8.04v14.92c0 2.225-2.076 4.04-4.622 4.04H4.622C2.076 27 0 25.185 0 22.96V8.04C0 5.816 2.076 4 4.622 4Zm24.58 2.767c.805-.492 1.913-.32 2.476.382.564.703.368 1.672-.436 2.165l-14.223 8.702a1.99 1.99 0 0 1-2.038 0L.757 9.314c-.804-.493-1-1.462-.436-2.165.563-.703 1.671-.874 2.475-.382L16 14.847l13.203-8.08Z" />
    </symbol>
  )
}

const MailStandaloneContent = standalone(MailSymbol, ID)

export const Mail = styled(function MailStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-mail">
      <MailStandaloneContent />
    </Icon>
  )
})``

export const MailLightweight = styled(function MailComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-mail">
      {lightweight(ID)}
    </Icon>
  )
})``
